'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = mapChildren;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsGenerator = require('./propsGenerator');

var _propsGenerator2 = _interopRequireDefault(_propsGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterUnMountChildren = function filterUnMountChildren(children) {
  return children.filter(function (child) {
    return !child.willUnmount;
  });
};

function mapChildren(props, state) {
  var childrenStoreInState = state.childrenStoreInState,
      willLeave = state.willLeave,
      willEnter = state.willEnter;
  var durationSeconds = props.durationSeconds,
      delaySeconds = props.delaySeconds,
      reverseDelaySeconds = props.reverseDelaySeconds,
      onComplete = props.onComplete;


  if (!Array.isArray(childrenStoreInState) || !Array.isArray(props.children)) {
    return null;
  }

  var children = childrenStoreInState;

  if (willLeave) {
    children = filterUnMountChildren(childrenStoreInState);
  } else if (willEnter) {
    children = props.children;
  }

  return children.map(function (child) {
    if (!child) return null;

    var componentProps = {};
    var startAnimation = true;

    var _child$willMount = child.willMount,
        willMount = _child$willMount === undefined ? false : _child$willMount,
        _child$willUnmount = child.willUnmount,
        willUnmount = _child$willUnmount === undefined ? false : _child$willUnmount,
        childProps = child.props;

    var isAnimateComponent = child.type && child.type.displayName && child.type.displayName === 'ReactSimpleAnimate';

    if (isAnimateComponent) {
      if (willMount) {
        startAnimation = willEnter;
      } else if (willUnmount) {
        startAnimation = willLeave;
      }
    } else {
      componentProps = (0, _propsGenerator2.default)(_extends({}, props), state, {
        willUnmount: willUnmount,
        willMount: willMount
      });
    }

    return _react2.default.cloneElement(child, _extends({}, childProps, !isAnimateComponent && componentProps.style ? { style: componentProps.style } : {
      startAnimation: startAnimation,
      durationSeconds: durationSeconds,
      delaySeconds: delaySeconds,
      reverseDelaySeconds: reverseDelaySeconds,
      onComplete: onComplete
    }));
  });
}